import RubyCodeEditor from './RubyCodeEditor';

export default RubyCodeEditor;